// extracted by mini-css-extract-plugin
module.exports = {"bf-tooltip":"bf-tooltip__fTle1","view-only-circle":"view-only-circle__yR-7l"};